import type { BannerProps } from '../Banner';

type GetVisibleBlocksProps = {
  blocks: NonNullable<BannerProps['blocks']>;
  isColumn: boolean;
  isNarrowViewport: boolean;
};

export function getVisibleBlocks({
  blocks,
  isColumn,
  isNarrowViewport
}: GetVisibleBlocksProps) {
  const desktopVisibleBlocks = checkVisibility('desktopOnly', blocks, isColumn);
  const mobileVisibleBlocks = checkVisibility('mobileOnly', blocks, isColumn);

  return isNarrowViewport ? mobileVisibleBlocks : desktopVisibleBlocks;
}

function checkVisibility(
  key: 'desktopOnly' | 'mobileOnly',
  blocks: GetVisibleBlocksProps['blocks'],
  isColumn: GetVisibleBlocksProps['isColumn']
) {
  return blocks.filter(
    (block) =>
      block?.visible &&
      (isColumn || block.type !== 'iframe') &&
      (block.devicesVisible === 'allDevices' || block.devicesVisible === key)
  );
}
